module.exports = __webpack_public_path__ + "static/media/icon-empty-background.f2ad8ce8.svg";